import Component from '../app/component'
import Glide from '@glidejs/glide'
import mediaQueries from '../plugins/media-queries.js'

export default class GalleryComponent extends Component {
  constructor (el) {
    super(el)
    this.data = {}
  }

  init () {
    this.setup()
  }

  setup () {
    this.glide = new Glide(this.el, {
      type: 'carousel',
      startAt: 0,
      perView: mediaQueries.test('small') ? 1.15 : 2.4,
      autoplay: 5000,
      gap: 0
    })
    this.glide.mount()
    
    if (this.refs.next) {
      this.refs.next.addEventListener('click', () => {
        this.glide.go('>')
      })
    }
    
    if (this.refs.prev) {
      this.refs.prev.addEventListener('click', () => {
        this.glide.go('<')
      })
    }
  }
}
